<template>
  <div class="accusation-history">
    <div class="accuse-item" v-for="item in list" :key="item.time">
      <div class="desc">{{ item.desc }}</div>
      <div class="time">{{ timeStr(item.time) }}</div>
      <div class="result">{{ item.result }}</div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import '../../lib/utils'
import { getUserReportDetail } from '@api/resourceApi'

export default {
  name: 'AccusationHistory',
  data() {
    return {
      list: []
    }
  },
  created() {
    native.wrap('setTitle')({
      title: '举报详情'
    })

    getUserReportDetail({
      toUid: this.$route.query.uid
    })
      .then((res) => {
        this.list = res.map((e) => {
          return {
            desc: e.reason,
            time: e.timestamp,
            result: e.result
          }
        })
      })
      .catch((err) => {
        console.error(err)
        native.wrap('toast')({
          msg: err.errMsg || err,
          style: '2'
        })
      })

    lego.send({
      pagetype: 'ACCUSATION_HISTORY',
      actiontype: 'PAGE_SHOW',
      backup: {
        touid: this.$route.query.uid
      }
    })
  },
  methods: {
    timeStr(time) {
      return new Date(Number(time)).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'AccusationHistory.less';
</style>
